import { action } from 'satcheljs';
import type { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';

export let updateDateRangeType = action(
    'updateDateRangeType',
    (
        dateRangeType: DateRangeType,
        store: CalendarSurfaceStore,
        numDaysInDayRange: number = 1,
        forceUpdate: boolean = false,
        isUserChange: boolean = true
    ) => ({
        dateRangeType: dateRangeType,
        store: store,
        numDaysInDayRange: numDaysInDayRange,
        forceUpdate: forceUpdate,
        isUserChange: isUserChange,
    })
);
